import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'James M.',
  role: 'Senior Club Coach',
  text: '"I planned my entire season in one evening. Every session now has a clear objective."'
}, {
  name: 'Coach David',
  role: 'Youth Coach',
  text: '"The progressions are logical and the players can feel themselves improving."'
}, {
  name: 'Priya T.',
  role: 'Academy Coach',
  text: '"Everything I need is right there. No more hours searching for drills."'
}];
export function SocialProof() {
  return <section className="bg-ink px-5 pb-14 md:pb-20" data-id="element-214" data-mp="8g11h20myprx">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5" data-id="element-215" data-mp="3ptej8pstxxjl">
        {testimonials.map(t => <figure key={t.name} className="bg-white p-5 md:p-7 flex flex-col h-full" data-id="element-216" data-mp="3urpsaybaw40r">
            <div className="flex gap-1 mb-4" aria-label="Rated 5 out of 5" data-id="element-217" data-mp="mbwbeid24qj6">
              {[...Array(5)].map((_, i) => <Star key={i} className="fill-neon text-neon" size={15} data-id="element-218" data-mp="1u9l6ld1zcb9u" data-mpi={i} />)}
            </div>
            <blockquote className="text-gray-800 italic text-[0.95rem] md:text-[1.05rem] leading-relaxed flex-grow" data-id="element-219" data-mp="1pb9xj4jie4so">
              {t.text}
            </blockquote>
            <figcaption className="mt-5 pt-4 border-t border-gray-200" data-id="element-220" data-mp="241h9d1f0gpke">
              <span className="font-bold text-gray-900 text-sm md:text-base" data-id="element-221" data-mp="1z7d2sj9nqjju">
                {t.name}
              </span>{' '}
              <span className="text-gray-500 text-xs md:text-sm" data-id="element-222" data-mp="2d25o5yc8atyc">{t.role}</span>
            </figcaption>
          </figure>)}
      </div>
    </section>;
}